import React from "react";
import * as Sentry from "@sentry/react";
import FallbackStub from "./FallbackStub";

export function withErrorBoundary<T extends Record<string, any>>(Component: React.ComponentType<T>) {
  return Sentry.withErrorBoundary(Component, { fallback: FallbackStub });
}
